"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProductType;
(function (ProductType) {
    ProductType["Default"] = "default";
    ProductType["VariantShell"] = "variantShell";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var StockStatus;
(function (StockStatus) {
    StockStatus["InStock"] = "inStock";
    StockStatus["OutOfStock"] = "outOfStock";
    StockStatus["OnBackOrder"] = "onBackOrder";
})(StockStatus = exports.StockStatus || (exports.StockStatus = {}));
var BackorderStatus;
(function (BackorderStatus) {
    BackorderStatus["Purchase"] = "purchase";
    BackorderStatus["Notify"] = "notify";
})(BackorderStatus = exports.BackorderStatus || (exports.BackorderStatus = {}));
var BookingServiceType;
(function (BookingServiceType) {
    BookingServiceType["Appointment"] = "appointment";
    BookingServiceType["Event"] = "event";
})(BookingServiceType = exports.BookingServiceType || (exports.BookingServiceType = {}));
var CartItemStatus;
(function (CartItemStatus) {
    CartItemStatus["InvalidConfiguration"] = "invalidConfiguration";
    CartItemStatus["OutOfStock"] = "outOfStock";
    CartItemStatus["BundleMissingProducts"] = "bundleMissingProducts";
    CartItemStatus["BookingSlotUnavailable"] = "bookingSlotUnavailable";
    CartItemStatus["BookingRequired"] = "bookingRequired";
    CartItemStatus["TooFew"] = "tooFew";
    CartItemStatus["TooMany"] = "tooMany";
})(CartItemStatus = exports.CartItemStatus || (exports.CartItemStatus = {}));
var DiscountType;
(function (DiscountType) {
    DiscountType["Automatic"] = "automatic";
    DiscountType["Code"] = "code";
})(DiscountType = exports.DiscountType || (exports.DiscountType = {}));
var DiscountOfferType;
(function (DiscountOfferType) {
    DiscountOfferType["Percentage"] = "percentage";
    DiscountOfferType["Fixed"] = "fixed";
    DiscountOfferType["NewPrice"] = "newPrice";
})(DiscountOfferType = exports.DiscountOfferType || (exports.DiscountOfferType = {}));
var ShippingType;
(function (ShippingType) {
    ShippingType["FlatRate"] = "flatRate";
    ShippingType["Pickup"] = "pickup";
    ShippingType["Free"] = "free";
})(ShippingType = exports.ShippingType || (exports.ShippingType = {}));
var OrderType;
(function (OrderType) {
    OrderType["Order"] = "order";
    OrderType["Quote"] = "quote";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
var StatType;
(function (StatType) {
    StatType["PageView"] = "pageView";
    StatType["ProductView"] = "productView";
    StatType["CartAdd"] = "cartAdd";
    StatType["Checkout"] = "checkout";
    StatType["OrderCreated"] = "orderCreated";
    StatType["OrderLine"] = "orderLine";
    StatType["Custom"] = "custom";
    StatType["FormSubmit"] = "formSubmit";
})(StatType = exports.StatType || (exports.StatType = {}));
var VariantType;
(function (VariantType) {
    VariantType["Color"] = "color";
    VariantType["Size"] = "size";
    VariantType["String"] = "string";
    VariantType["Image"] = "image";
    VariantType["Icon"] = "icon";
})(VariantType = exports.VariantType || (exports.VariantType = {}));
var CustomizeOptionType;
(function (CustomizeOptionType) {
    CustomizeOptionType["String"] = "string";
    CustomizeOptionType["Number"] = "number";
    CustomizeOptionType["NumberMultiplier"] = "numberMultiplier";
    CustomizeOptionType["Checkbox"] = "checkbox";
    CustomizeOptionType["Radio"] = "radio";
    CustomizeOptionType["Stepper"] = "stepper";
    CustomizeOptionType["StringStepper"] = "stringStepper";
    CustomizeOptionType["Color"] = "color";
})(CustomizeOptionType = exports.CustomizeOptionType || (exports.CustomizeOptionType = {}));
var AuthResponseCodes;
(function (AuthResponseCodes) {
    AuthResponseCodes[AuthResponseCodes["Success"] = 200] = "Success";
    AuthResponseCodes[AuthResponseCodes["Fail"] = 400] = "Fail";
})(AuthResponseCodes = exports.AuthResponseCodes || (exports.AuthResponseCodes = {}));
var AuthResponseMessages;
(function (AuthResponseMessages) {
    AuthResponseMessages["RegisterSuccess"] = "registerSuccess";
    AuthResponseMessages["UserAlreadyExists"] = "userAlreadyExists";
    AuthResponseMessages["LoginSuccess"] = "loginSuccess";
    AuthResponseMessages["WrongUsernameOrPassword"] = "wrongUsernameOrPassword";
})(AuthResponseMessages = exports.AuthResponseMessages || (exports.AuthResponseMessages = {}));
var PriceType;
(function (PriceType) {
    PriceType["Default"] = "default";
    PriceType["ByAppointment"] = "byAppointment";
})(PriceType = exports.PriceType || (exports.PriceType = {}));
var TemplateRole;
(function (TemplateRole) {
    TemplateRole["FrontPage"] = "frontPage";
    TemplateRole["Page"] = "page";
    TemplateRole["Category"] = "category";
    TemplateRole["Product"] = "product";
    TemplateRole["ProductPage"] = "productPage";
    TemplateRole["Cart"] = "cart";
    TemplateRole["Checkout"] = "checkout";
    TemplateRole["Login"] = "login";
    TemplateRole["MyPage"] = "myPage";
    TemplateRole["NoAccess"] = "noAccess";
})(TemplateRole = exports.TemplateRole || (exports.TemplateRole = {}));
var RubicsFormFieldType;
(function (RubicsFormFieldType) {
    RubicsFormFieldType["String"] = "string";
    RubicsFormFieldType["Text"] = "text";
    RubicsFormFieldType["Number"] = "number";
    RubicsFormFieldType["File"] = "file";
    RubicsFormFieldType["Select"] = "select";
    RubicsFormFieldType["Radio"] = "radio";
    RubicsFormFieldType["Checkbox"] = "checkbox";
    RubicsFormFieldType["Color"] = "color";
    RubicsFormFieldType["Date"] = "date";
    RubicsFormFieldType["DateTimeLocal"] = "datetime-local";
    RubicsFormFieldType["Time"] = "time";
    RubicsFormFieldType["Email"] = "email";
    RubicsFormFieldType["Hidden"] = "hidden";
    RubicsFormFieldType["Tel"] = "tel";
    RubicsFormFieldType["Url"] = "url";
    RubicsFormFieldType["Info"] = "info";
})(RubicsFormFieldType = exports.RubicsFormFieldType || (exports.RubicsFormFieldType = {}));
//# sourceMappingURL=types.js.map